import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { getIsLoggedInSelector } from 'reducers/profile/selectors';

// Reset query cache if user perform login/logout
const useQueryCacheMonitoring = () => {
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.resetQueries();
  }, [isLoggedIn, queryClient]);
};

export default useQueryCacheMonitoring;
